
export default {
    name: 'antecedent-allergologie-familiaux',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            save_loading: false,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'collateraux', 'ascendant', 'descendant',
            ],
        }
    },
    computed: {
        antecedent_allergo_familiaux() {
            return this.$store.getters["antecedent_allergo_familiaux"];
        },
    },
    mounted() {
        this.listeChampATCDAllergoFamiliaux()
    },
    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_allergo_familiaux.length > 0) {
                    v = this.antecedent_allergo_familiaux[index]['field_content']
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },
        
        async listeChampATCDAllergoFamiliaux() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_familiaux',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_familiaux',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDAllergoFamiliaux()
                }

                this.save_loading = false
            })
        }
    }
}


